import Modal from 'react-modal';
import { useState, useEffect } from 'react';
import api from '../../../config.js';
import './log.css';
import Title from '../../../components/Title';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import { FaCog, FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import ReactTooltip from "react-tooltip";
import { customFullModal, showMessageError } from '../../../classes/functions.js';
import JSONPretty from 'react-json-pretty';
import InputDate from '../../../components/Inputs/Date/index.js';

export default function IntegrationLog() {
  const [list, setList] = useState([]);
  
  const [qtdePage, setQtdePage] = useState(1000);
  const [limitPage, setLimitPage] = useState();
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState();

  const [search_routine, setSearchRoutine] = useState('');
  const [search_code, setSearchCode] = useState('');

  const [json_modal, setJsonModal] = useState(false);
  const [json_body, setJsonBody] = useState({});
  const [filters, setFilters] = useState({
    search_date: ""
  });
  const [carrying, setCarrying] = useState(true);

  useEffect(() => {
    async function loadLog() {
      let data = {
        data: {
          routine: search_routine,
          date: filters.search_date,
          code: search_code,
          page: page,
          qtdePage: qtdePage,
        }
      };

      api.post("/api/integration/getListLogError", data)
        .then((response) => {
          setList(response.data.dados);
          setTotal(response.data.qtde);

          setLastPage(response.data.qtde, qtdePage);
          setCarrying(false);
        }
        ).catch((error) => {
          setCarrying(false);
          showMessageError(error.response.data);
        });
    }

    loadLog();

    return () => {

    }
  }, []);

  function setLastPage(aux_qtde, aux_qtdePage) {
    let lastPageIndex = parseInt(aux_qtde / aux_qtdePage);

    if ((aux_qtde % aux_qtdePage) > 0) {
      setLimitPage(lastPageIndex + 1);
    } else {
      setLimitPage(lastPageIndex);
    }
  }

  function pesquisar() {
    setCarrying(true);
    setPage(1);
    setQtdePage(qtdePage);

    let data = {
      data: {
        routine: search_routine,
        date: filters.search_date,
        code: search_code,
        page: page,
        qtdePage: qtdePage,
      }
    };

    api.post("/api/integration/getListLogError", data)
      .then((response) => {
        setList(response.data.dados);
        setTotal(response.data.qtde);
        setLastPage(response.data.qtde, qtdePage);
        setCarrying(false);
      }
      ).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
  }

  function nextPage() {
    if (limitPage != page) {
      setCarrying(true);

      let data = {
        data: {
          routine: search_routine,
          date: filters.search_date,
          code: search_code,
          page: page + 1,
          qtdePage: qtdePage,
        }
      };

      api.post("/api/integration/getListLogError", data)
        .then((response) => {
          setList(response.data.dados);
          setTotal(response.data.qtde);
          setCarrying(false);

          setPage(page + 1);
          setQtdePage(qtdePage);
        }
        ).catch((error) => {
          showMessageError(error.response.data);
          setCarrying(false);
        });
    }
  }

  function lastPage() {
    if (limitPage != page) {
      setCarrying(true);

      let data = {
        data: {
          routine: search_routine,
          date: filters.search_date,
          code: search_code,
          page: limitPage,
          qtdePage: qtdePage,
        }
      };

      api.post("/api/integration/getListLogError", data)
        .then((response) => {
          setList(response.data.dados);
          setTotal(response.data.qtde);
          setCarrying(false);

          setPage(limitPage);
          setQtdePage(qtdePage);
        }
        ).catch((error) => {
          showMessageError(error.response.data);
          setCarrying(false);
        });
    }
  }

  function firstPage() {
    if (page != 1) {
      setCarrying(true);

      let data = {
        data: {
          routine: search_routine,
          date: filters.search_date,
          code: search_code,
          page: 1,
          qtdePage: qtdePage,
        }
      };

      api.post("/api/integration/getListLogError", data)
        .then((response) => {
          setList(response.data.dados);
          setTotal(response.data.qtde);
          setCarrying(false);

          setPage(1);
          setQtdePage(qtdePage);
        }
        ).catch((error) => {
          showMessageError(error.response.data);
          setCarrying(false);
        });
    }
  }

  function previewPage() {
    if (page != 1) {
      setCarrying(true);

      let data = {
        data: {
          routine: search_routine,
          date: filters.search_date,
          code: search_code,
          page: page - 1,
          qtdePage: qtdePage,
        }
      };

      api
        .post("/api/integration/getListLogError", data)
        .then((response) => {
          setList(response.data.dados);
          setTotal(response.data.qtde);
          setCarrying(false);

          setPage(page - 1);
          setQtdePage(qtdePage);
        }
        ).catch((error) => {
          showMessageError(error.response.data);
          setCarrying(false);
        });
    }
  }

  function closeModal() {
    setJsonModal(false);
  }

  return (
    <div>
      <Header />
      <Division />
      <Lateral />
      <ReactTooltip />

      {carrying && <div className="content">
        <div className="divCarrying">
          <span>Carregando..</span>
          <FaCog icon="spinner" className="spinner" />
        </div>
      </div>}
      {!carrying && <div className="content">
        <Title name="Log de Erro Integração">

        </Title>

        <div className="container">

          <div className="divGroup">
            <select className='selectQtdeItens' value={qtdePage} onChange={(e) => { setQtdePage(e.target.value); }}>
              <option value="1000">Itens por página</option>
              <option value="10">10</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="500">500</option>
              <option value="1000">1000</option>
            </select>
            <button className="buttonInsert pullRight" onClick={pesquisar}>
              Pesquisar
            </button>
          </div>
          <br />
          <div className="divGroup">
            <table>
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">
                    <div className="formDiv">
                      <input type="text" placeholder="Rotina" value={search_routine} onChange={(e) => setSearchRoutine(e.target.value)} maxLength="30" />
                    </div>
                  </th>
                  <th scope="col">
                    <div className="formDiv" style={{width: "120%"}}>
                      <InputDate filters={filters} setFilters={setFilters} propertyFilter="search_date" />
                    </div>
                  </th>
                  <th scope="col">Hora</th>
                  <th scope="col">Usuário</th>
                  <th scope="col"><div className="formDiv"><input type="text" placeholder="Registro" value={search_code} onChange={(e) => setSearchCode(e.target.value)} maxLength="30" />
                    </div>
                  </th>
                  <th scope="col">URL</th>
                  <th scope="col">Parâmetro de Entrada</th>
                  <th scope="col">Código Retorno</th>
                  <th scope="col">Objeto Retorno</th>
                </tr>
              </thead>
              <tbody>
                {list.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.routine}</td>
                      <td>{item.date}</td>
                      <td>{item.hour}</td>
                      <td>{item.user}</td>
                      <td>{item.code}</td>
                      <td>{item.url}</td>
                      <td><button type="button" className="buttonTable" onClick={() => {setJsonBody(item.body); setJsonModal(true)}}>Ver Objeto</button></td>
                      <td>{item.return_code}</td>
                      <td><button type="button" className="buttonTable" onClick={() => {setJsonBody(item.return_body); setJsonModal(true)}}>Ver Objeto</button></td>
                    </tr>
                  )
                })}
                {list.length == 0 && <tr>
                  <td colSpan={10}><label className='required'>Nenhum registro encontrado!</label></td>
                </tr>}
              </tbody>
            </table>
          </div>
        </div>
        <br />
        <div className="divGroupPagination">
          <button data-tip="Primeira página" type="button" onClick={firstPage} className="buttonFirstPage"><FaArrowLeft color="#001675" size={17} /><FaArrowLeft color="#001675" size={17} /></button>
          <button data-tip="Página anterior" type="button" onClick={previewPage} className="buttonPreviewPage"><FaArrowLeft color="#001675" size={17} /></button>
          <div className="divLabelPagination">
            <center><label className="labelPage">Exibindo página {page} de {limitPage}</label></center>
            <center><label className="labelPage">Exibindo {qtdePage} de {total} registros</label></center>
          </div>
          <button data-tip="Próxima página" type="button" onClick={nextPage} className="buttonNextPage"><FaArrowRight color="#001675" size={17} /></button>
          <button data-tip="Última página" type="button" onClick={lastPage} className="buttonLastPage"><FaArrowRight color="#001675" size={17} /><FaArrowRight color="#001675" size={17} /></button>
        </div>
      </div>}

      <Modal
        isOpen={json_modal}
        onRequestClose={closeModal}
        style={customFullModal}
        contentLabel="Conferred"
        ariaHideApp={false}
      >
        <div className="body-modal">
          <div className="formDiv jsonItem">
            <div className="divGroup">
              <JSONPretty id="json-pretty" data={json_body}></JSONPretty>
            </div>
          </div>
          <div className="formDiv">
            <button type="button" className="buttonCancel" onClick={closeModal}>Fechar</button>
          </div>
        </div>
      </Modal>
    </div>
  )
}